<template>
    <button
        class="vz_btn"
        :class="[
            variant && !outline ? `btn-${variant}` : '',
            variant && outline ? `btn-outline-${variant}` : '',
            block ? 'btn-block' : '',
        ]"
        :attrs="[disabled]"
        :disabled="disabled || isLoading"
        @click="btnClick"
    >
        <span v-if="prefixIcon && !isLoading"><fa :class="iconClass" :icon="[iconType, prefixIcon]" /></span>
        <div class="flex items-center justify-center gap-4">
            <div v-if="isLoading" class="flex flex-row gap-1">
                <div
                    class="w-1.5 h-1.5 rounded-full animate-bounce [animation-delay:.7s]"
                    :class="`${outline ? 'bg-blue-500' : 'bg-blue-100'}`"
                ></div>
                <div
                    class="w-1.5 h-1.5 rounded-full animate-bounce [animation-delay:.3s]"
                    :class="`${outline ? 'bg-blue-500' : 'bg-blue-100'}`"
                ></div>
                <div
                    class="w-1.5 h-1.5 rounded-full animate-bounce [animation-delay:.7s]"
                    :class="`${outline ? 'bg-blue-500' : 'bg-blue-100'}`"
                ></div>
            </div>
            <span>{{ isLoading ? "Loading" : btnText }}</span>
        </div>
        <span v-if="suffixIcon"><fa :class="iconClass" :icon="[iconType, suffixIcon]" /></span>
    </button>
</template>
<script setup>
const props = defineProps({
    btnText: {
        type: String,
        default: "",
    },
    variant: {
        type: String,
        default: "",
    },
    outline: {
        type: Boolean,
        default: false,
    },
    block: {
        type: Boolean,
        default: false,
    },
    prefixIcon: {
        type: String,
        default: "",
    },
    suffixIcon: {
        type: String,
        default: "",
    },
    iconType: {
        type: String,
        default: "fal",
    },
    iconClass: {
        type: String,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
});
const emits = defineEmits(["buttonClick"]);
const btnClick = () => {
    emits("buttonClick");
};
</script>
<style scoped>
/* Base button styling */
/* :class="[
        variant!=='white' && !outline ? `btn-${variant} bg-${variant}-500 border-${variant}-500 text-white` :
        variant==='white' && !outline ? 'bg-white !text-black-600 border-white':'',
        outline ? `btn-outline-${variant} bg-transparent text-${variant}-500 border-${variant}-500` : '',
        outline && variant === 'white' ? 'text-white border-white' : '',
        block ? 'block w-full' : '',
]" */
.vz_btn {
    @apply flex sm:rounded rounded-full items-center border justify-center font-medium leading-3 text-sm py-2 transition-all cursor-pointer text-center md:px-3 px-3 gap-1 h-8;
}
.vz_btn .svg-inline--fa {
    @apply h-4 align-top;
}
.vz_btn .svg-inline--fa.fa-chevron-down {
    @apply text-[10px] w-[10px];
}
.btn-block {
    @apply block w-full;
}
.btn-gray {
    @apply bg-gray-100 border-gray-100 text-black-500 dark:text-white dark:border-black-900 dark:bg-black-900;
}
.btn-blue {
    @apply bg-blue-500 border-blue-500 text-white dark:text-black-900;
}
.btn-black {
    @apply bg-black-500 border-black-500 text-white dark:text-black-900 dark:bg-white;
}
.btn-white {
    @apply bg-white border-white text-black-600 dark:text-white dark:bg-black-600 dark:border-black-600;
}

.btn-green {
    @apply bg-green-500 border-green-500 text-white dark:text-black-900;
}
.btn-red {
    @apply bg-red-500 border-red-500 text-white dark:text-black-900;
}
.btn-gray {
    @apply bg-gray-100 border-gray-100 text-black-500 dark:text-white dark:border-black-900 dark:bg-black-900;
}
.btn-outline-blue {
    @apply bg-transparent border-solid border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white;
}
.btn-outline-black {
    @apply bg-transparent border-black-500 text-black-500 hover:bg-black-500 hover:text-white dark:text-white dark:hover:bg-white dark:border-white dark:hover:text-black-900;
}
.btn-outline-white {
    @apply bg-transparent border-white text-white hover:bg-white hover:text-black-500 dark:text-black-600 dark:hover:bg-black-600 dark:border-black-600 dark:hover:text-white;
}
.btn-outline-green {
    @apply bg-transparent border-green-500 text-green-500 hover:bg-green-500 hover:text-white;
}
.btn-outline-red {
    @apply bg-transparent border-red-500 text-red-500 hover:bg-red-500 hover:text-white;
}
.vz_btn[disabled] {
    @apply cursor-not-allowed opacity-50;
}
</style>
